import {appFetch, AppFetchResponse} from "../utils/appFetch";
import {ManagerFormValuesProps} from "../components/shopManagers/NewShopManagerModal";
import {BlackoutDateProps} from "../types/BlackoutPeriod";

export const updateCheckoutIgnore = async (domain: string, checkoutId: number, shouldIgnore: boolean): Promise<AppFetchResponse> => {
    return appFetch({
        endpoint: `checkouts/${checkoutId}/ignore`,
        method: 'PATCH',
        headers: {
            "Content-Type": "application/json",
        },
        params: {
            shouldIgnore,
            checkoutId,
        },
        domain,
    });
}